import { render, staticRenderFns } from "./OfferFormMedicalServicesCard.vue?vue&type=template&id=07cfde05&"
import script from "./OfferFormMedicalServicesCard.vue?vue&type=script&lang=js&"
export * from "./OfferFormMedicalServicesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports